<template>
  <!-- <div class="index-content" > -->
  <div class="index-content">
      <div class="c-title" :title="Object.keys(dataOrigin)[0]">{{ Object.keys(dataOrigin)[0] }}</div>
      <ul class="c-content">
        <li v-for="(item, index) in Object.values(dataOrigin)[0]" :key="index"><index-item @click.native="openDoc(item.url,item.id)" :dataDetial="item" :cKey="index"/></li>
      </ul>
    <div style="clear: both"></div>
    <el-drawer
      :title="'飞书文档'"
      :visible.sync="RegistrarioneDrawer"
      direction="rtl"
      :before-close="handleCompanyInfoBeforeClose"
      size="60%"
    >
      <div style="margin-left: 0.4rem;margin-right: 0.4rem">
        <div class="m-tabs-content_amt">
          <div class="blocka">
            <el-button
            type="primary"
            size="mini"
            style="font-size: 0.28rem;margin-bottom: 0.2rem;"
                @click="readRecord"
            >新窗口打开
            </el-button>
            <el-tabs v-model="showTabPane" type="border-card" @tab-click="handle_chooseReadStatus">
              <el-tab-pane label="文档展示" name="first">
                <div
                 ref="fsDrawer"
                 id="fsDrawer"
                 >
                </div>
              </el-tab-pane>
              <el-tab-pane label="阅读记录" name="theSecond">
                <el-row class="count_style">
                    当前文档阅读总次数：{{ count ? count : 0 }}
                </el-row>
                <el-collapse
                  v-for="(records, index) in remarksLog"
                  :key="index"
                  accordion
                  v-model="activeName"
                  style="border-bottom: 1px solid #ebeef5"
                >
                  <el-collapse-item
                    :title="records.month + ' 操作记录详情'"
                    :name="index + 1"
                  >
                    <el-timeline>
                      <el-timeline-item
                        :timestamp="item.created_at"
                        v-for="(item, index) in records.record"
                        :key="index"
                        placement="top"
                      >
                        <el-card>
                          <p v-if="item.operation">{{ item.ope_name }} 在 {{ item.created_at }} 时 {{ item.operation }}</p>
                          <p v-if="!item.operation">无</p>
                        </el-card>
                      </el-timeline-item>
                    </el-timeline>
                  </el-collapse-item>
                </el-collapse>
              </el-tab-pane>
              <el-tab-pane label="未读人员名单" name="unRead">
                <el-row gutter="20">
                  <el-col style="font-size: medium;margin-bottom: 0.2rem" :span="3" v-for="(item,index) in unReadData" :key="index">{{item.username}}</el-col>
                </el-row>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import IndexItem from './IndexItem'
export default {
  name: 'IndexContent',
  components: { IndexItem },
  props: ['dataOrigin'],
  data () {
    return {

      docUniId: '',
      RegistrarioneDrawer: false,
      showTabPane: 'first',
      remarksLog: [],
      unReadData: [],
      count: 0,
      activeName: 1,
      divfs: null,
      itemUrl: null
    }
  },
  computed: {
    collapse () {
      return this.$store.state.collapse
    }
  },
  methods: {
    handle_chooseReadStatus (tab) {
      if (tab.name === 'unRead') this.getUnReadData()
    },
    getUnReadData () {
      if (!this.docUniId) return false
      this.$axios.get('api/adminuser/get_unread', {
        params: {
          feishuId: this.docUniId
        }
      }).then(({data}) => {
        if (data.code === 1) {
          this.unReadData = data.data
        }
      }).catch()
    },
    readRecord () {
      sessionStorage.removeItem('feiUrl')
      // let newPage = this.$router.resolve({
      //   path: '/documentation',
      //   query: { url: this.itemUrl }
      // })
      // window.open(newPage.href, '_blank')
      let newPage = this.$router.resolve({
        path: `/documentation`
      })
      sessionStorage.setItem('feiUrl', this.itemUrl)
      window.open(newPage.href, '_blank')
    },
    handleCompanyInfoBeforeClose (done) {
      this.$refs.fsDrawer.innerHTML = ''
      this.itemUrl = null
      this.docUniId = ''
      done()
    },
    openDoc (url, id) {
      this.divfs = null
      this.docUniId = id
      if (!url) {
        this.$message.warning('没有填写文档地址!')
        return false
      }
      this.itemUrl = url
      this.flyingDocument(id)
      this.sign(url)
      this.RegistrarioneDrawer = true
      // let newPage = this.$router.resolve({
      //   path: '/documentation',
      //   query: { url }
      // })
      // window.open(newPage.href, '_blank')
      this.$axios
        .post('api/index/store_read_log', {
          id
        })
        .then(({ data }) => {
          if (data.code === 1) {
            // this.comNoticeData = data.data.data
            // this.total = data.data.total
          }
        })
        .catch()
    },
    sign (url) {
      this.$axios.get('/api/admin/fei_shu/documentation/auth?url=' + url)
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            this.url = data.data.url
            this.signature(data.data.signature, data.data.timestamp, data.data.nonceStr, data.data.url)
          }
        })
    },
    signature (signature, timestamp, nonceStr, url) {
      window.webComponent.config({
        signature: signature,
        appId: 'cli_a2dafca2d3799013',
        timestamp: timestamp,
        nonceStr: nonceStr,
        url: url,
        jsApiList: ['DocsComponent'],
        lang: 'zh'
      }).then((res) => {
        let that = this
        that.myComponent = window.webComponent.render(
          'DocsComponent',
          {
            src: that.url,
            height: '800px',
            minHeight: '500px',
            width: '100%'
          },
          document.querySelector('#fsDrawer')
        )
        that.myComponent.config.setFeatureConfig({
          HEADER: {
            enable: false
          },
          LIKE: {
            enable: false
          },
          MORE_MENU: {
            enable: false
          },
          COMMENT: {
            partial: [
              false
            ]
          }
        })
      })
    },
    flyingDocument (id) {
      this.$axios
        .get('api/fly_book/getlog', {
          params: {
            id
            // getColumn: this.getColumn,
            // getColumnValue: this.getColumnValue
          }
        })
        .then(({ data }) => {
          if (data.code === 0) {
            this.remarksLog = data.data.remarksLog
            this.count = data.data.count
          }
        }).catch()
    }
  },
  mounted () {
    // console.log(Object.values(this.dataOrigin)[0])
  }
}
</script>

<style scoped>
.index-content {
  padding: 10px;
  background-color: rgb(245, 245, 245);
  border-radius: 5px;
}
.c-title {
  font-size: medium;
  font-weight: bold;
  margin-bottom: 15px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 270px;
}
.c-content {
  margin-left: 20px;
}
.c-content li {
  float: left;
  margin-right: 10px;
}
.el-drawer__wrapper >>> .el-drawer {
  overflow-y: auto;
}
.el-collapse >>> .el-collapse-item__header {
  color: #4C87FC;
  font-weight: bold;
}
  .count_style {
    padding: 2px 0 2px 0;
    font-size: 12px;
    color: #4C87FC;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/IndexContent.vue